import React from 'react';
import ClassNames from 'classnames';
import NavigationStore from '../../../Stores/NavigationStore';
import InternalOrExternalLink from "../../InternalOrExternalLink.js";

function NavigationMenuItemView({ parentActive, label, href }) {
    function isActive(label) {
        const { currentMenuSelection } = NavigationStore.getState();
        return currentMenuSelection && currentMenuSelection[currentMenuSelection.length-1] === label;
    }

    const active = parentActive !== false && isActive(label);

    return (
        <li className={ ClassNames({selected: active}, 'item') } title={ label }>
            <InternalOrExternalLink label={label} href={href} />
        </li>
    );
}

export default NavigationMenuItemView;
